import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "MassEditWrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_highlighted_feature = _resolveComponent("highlighted-feature")!
  const _component_MassEditModal = _resolveComponent("MassEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_highlighted_feature, {
      feature: _ctx.highlightedFeatureNameMassEdit,
      elementClassName: "HighlightedFeatureMassEdit",
      title: _ctx.highlightedFeatureTitle,
      content: _ctx.highlightedFeatureContent
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "NavigatorButton MassEditButton",
          disabled: !_ctx.areEnrolmentsSelected,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMassEditModal && _ctx.openMassEditModal(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "lnr-pencil MassEditButtonIcon" }, null, -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["feature", "title", "content"]),
    (_ctx.isMassEditModalShown)
      ? (_openBlock(), _createBlock(_component_MassEditModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ]))
}